<div class="offer-details-container">
    <div class="nova-toolbar__pre-header space-between items-center">
        <div class="flex-row justify-start items-center">
            <mat-icon (click)="goBack()">arrow_back</mat-icon>
            <div class="title">Create New Offer</div>
        </div>
        <div class="button-actions">
            <button type="button" class="mat-raised-button mat-secondary" color="secondary" (click)="cancelCreateOffer()"
                [disabled]="disableSubmitAndCancel">Cancel</button>
            <button type="submit" [disabled]="detailsFormGroup.invalid || disableSubmitAndCancel"
                class="mat-raised-button mat-primary" color="primary" (click)="createOffer()">
                <span
                    [matTooltip]="'Please enter appropriate fields to create the offer.'"
                    [matTooltipDisabled]="detailsFormGroup.valid">
                    Create Offer
                </span>
            </button>
        </div>
    </div>
    <ng-container>
        <nova-banner *ngIf="validateCandidateProfessionJobs" bannerType="alert"
            bannerMessage="Clinician's profession must match the job's profession. Please review and update before creating an Offer.">
        </nova-banner>
    </ng-container>
    <div class="offer-details-content flex-row-wrap justify-start gap-16">
        <mat-card class="info">
            <ng-template #loading>
                <div class="progress flex-grow">
                    <mat-progress-spinner mode="indeterminate" diameter="96"></mat-progress-spinner>
                </div>
            </ng-template>
            <form [formGroup]="detailsFormGroup">

                <table class="offer-info-table" aria-label="table">
                    <tbody>
                        <tr class="hidden">
                            <th scope="col"></th>
                            <th scope="col"></th>
                            <th scope="col"></th>
                        </tr>
                        <tr>
                            <td><span class="label-text">Agency *</span></td>
                            <td>
                                <mat-form-field class="mc-form-field mc-form-field__shift-type--width extended-field">
                                    <input type="text" matInput formControlName="vendorValues" [matAutocomplete]="vendorAuto">
                                    <mat-autocomplete #vendorAuto="matAutocomplete" [displayWith]="displayFieldName" (optionSelected)="agencySelection($event)">
                                        <mat-option *ngFor="let option of filteredVendorIdOptions | async" [value]="option" [disabled]="!option.hasAcceptedFacilities">
                                            {{ option.name }}
                                            {{ !option.hasAcceptedFacilities ? '(No Accepted Facilities)' : '' }}
                                        </mat-option>
                                    </mat-autocomplete>
                                    <mat-error *ngIf="hasError('vendorValues', 'required')">Agency is required</mat-error>
                                </mat-form-field>
                            </td>
                        </tr>
                        <tr>
                            <td><span class="label-text">Candidate *</span></td>
                            <td>
                                <mat-form-field>
                                    <input type="text"
                                           matInput
                                           formControlName="selectedCandidate"
                                           [errorStateMatcher]="matcher"
                                           [matAutocomplete]="candidateAuto">
                                    <mat-autocomplete #candidateAuto="matAutocomplete"
                                                    (optionSelected)="candidateSelection($event)"
                                                    [displayWith]="displayFieldName"
                                                    autoActiveFirstOption #auto="matAutocomplete">
                                        <mat-option *ngFor="let option of filteredCandidateIdOptions | async" [value]="option" [disabled]="!option.userId">
                                            {{ option.name }}
                                            {{ !option.userId ? '(no profile)' : '' }}
                                        </mat-option>
                                        <mat-option *ngIf="!filteredCandidateIdOptions">No candidates available to choose from.</mat-option>
                                    </mat-autocomplete>
                                    <mat-error>Please enter a Candidate.</mat-error>
                                </mat-form-field>
                                <span *ngIf="detailsFormGroup?.controls.selectedCandidate.value" style="padding-left: 20px">{{ detailsFormGroup?.controls.candidateEmail.value }}</span>
                            </td>
                        </tr>
                        <tr>
                            <td><span class="label-text">Agency Contact *</span></td>
                            <td>
                                <mat-form-field class="mc-form-field mc-form-field__shift-type--width">
                                    <mat-select formControlName="vendorContactId">
                                        <mat-option *ngFor="let option of vendorLookup?.contacts" [value]="option.id">{{ option.name }}</mat-option>
                                    </mat-select>
                                    <mat-error *ngIf="hasError('vendorContactId', 'required')">Agency Contact is required</mat-error>
                                </mat-form-field>
                            </td>
                        </tr>
                        <tr><td colspan="2"></td></tr>
                        <tr>
                            <td><span class="label-text">Contract Type</span></td>
                            <td>
                                <mat-form-field class="mc-form-field mc-form-field__shift-type--width">
                                    <mat-select formControlName="contractTypeId">
                                        <mat-option *ngFor="let option of lookups?.contracts" [value]="option.id">{{ option.code }}</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </td>
                        </tr>
                        <tr>
                            <td><span class="label-text">Position Type</span></td>
                            <td>
                                <span>{{ candidateProfessionTypeName }}</span>
                            </td>
                        </tr>

                        <tr><td colspan="2"></td></tr>
                        <tr>
                            <td><span class="label-text">System</span></td>
                            <td>
                                <mat-form-field class="mc-form-field mc-form-field__shift-type--width extended-field full-width">
                                    <input type="text" matInput formControlName="systemValues" [matAutocomplete]="systemAuto">
                                    <mat-autocomplete #systemAuto="matAutocomplete" [displayWith]="displayFieldName" (optionSelected)="systemSelection($event)">
                                        <mat-option *ngIf="!filteredSystemIdOptions">No systems available to choose from.</mat-option>
                                        <mat-option *ngFor="let option of filteredSystemIdOptions | async" [value]="option">{{ option.name }}</mat-option>
                                    </mat-autocomplete>
                                </mat-form-field>
                            </td>
                        </tr>
                        <tr>
                            <td><span class="label-text">Facility *</span></td>
                            <td>
                                <mat-form-field class="mc-form-field mc-form-field__shift-type--width extended-field full-width">
                                    <input matInput type="text" formControlName="facilityValues" [matAutocomplete]="facilityAuto" [errorStateMatcher]="matcher">
                                    <mat-autocomplete #facilityAuto="matAutocomplete" [displayWith]="displayFieldName" (optionSelected)="facilitySelection($event)">
                                        <mat-option *ngIf="!filteredFacilityIdOptions">No facilities available to choose from.</mat-option>
                                        <mat-option *ngFor="let facility of filteredFacilityIdOptions | async" [value]="facility">{{ facility.name }} - {{ facility.id }}</mat-option>
                                    </mat-autocomplete>
                                    <mat-error *ngIf="hasError('facilityValues', 'required')">Facility is required</mat-error>
                                </mat-form-field>
                            </td>
                        </tr>
                        <tr>
                            <td><span class="label-text">AM</span></td>
                            <td>
                                <span>{{ facilityLookup?.accountManager }}</span>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span class="label-text">Job Id</span>
                            </td>
                            <td>
                                <mat-form-field>
                                    <input type="number" matInput formControlName="jobId" [matAutocomplete]="jobIdAuto" (change)="jobIdSelection($event)">
                                    <mat-autocomplete #jobIdAuto="matAutocomplete" [displayWith]="displayJobIds" (optionSelected)="jobIdSelection($event)">
                                        <mat-option *ngFor="let job of filteredJobIdOptions | async" [value]="job">{{ job }} </mat-option>
                                    </mat-autocomplete>
                                </mat-form-field>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2"></td>
                        </tr>
                        <tr>
                            <td>
                                <span class="label-text">Candidate Profession</span>
                            </td>
                            <td>
                                <span>{{ candidateProfessionName }}</span>
                            </td>
                        </tr>
                        <ng-container>
                            <tr>
                                <td colspan="2"></td>
                            </tr>
                            <tr>
                                <td><span class="label-text">Job Profession</span>
                                </td>
                                <td>
                                    <span>{{ jobProfessionName }}</span>
                                </td>
                            </tr>
                            <tr *ngIf="validateCandidateProfessionJobs">
                                <td colspan="2">
                                    <mat-error>Clinician's profession must match the job's profession. Please review and update before creating
                                        an Offer.</mat-error>
                                </td>
                            </tr>
                        </ng-container>
                        <tr>
                            <td>
                                <span class="label-text">Job Specialty *</span>
                            </td>
                            <td>
                                <mat-form-field class="mc-form-field mc-form-field__shift-type--width extended-field">
                                    <mat-select formControlName="expertiseId" (selectionChange)="checkRateUpdateFields('Expertise')" [disabled]="!detailsFormGroup.controls.candidateProfessionId.value">
                                        <mat-option *ngFor="let option of expertise" [value]="option.id">{{ option.name }}</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </td>
                        </tr>
                        <tr><td colspan="2"></td></tr>
                        <ng-container>
                            <tr>
                                <td>
                                    <span class="label-text">Contract Length</span>
                                </td>
                                <td>
                                    <div>
                                        <mat-form-field class="contractLength contract-length-small-error">
                                            <input type="number" matInput (change)="calculateContractDates('weeksLengthChanged')"
                                                formControlName="contractLength">
                                                <mat-error>Please enter valid Weeks Length.</mat-error>
                                        </mat-form-field>
                                        <span class="label-text"> Weeks</span>
                                    </div>
                                    <div>
                                        <mat-form-field class="contractLength contract-length-small-error">
                                            <input type="number" matInput (change)="calculateContractDates('daysLengthChanged')"
                                                formControlName="contractLengthDays">
                                            <mat-error >Please enter valid Days Length.</mat-error>
                                        </mat-form-field>
                                        <span class="label-text"> Days</span>
                                        <mat-icon *ngIf="contractLengthDaysApprovalRequired" class="info-icon" [matTooltip]="contractLengthDaysInfoMessage">info</mat-icon>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td><span class="label-text">Start</span></td>
                                <td>
                                    <mat-form-field>
                                        <input matInput [matDatepicker]="picker" formControlName="startDate"
                                            (dateChange)="calculateContractDates('startDateChanged')" data-qa-id="StartDateInput">
                                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                        <mat-datepicker #picker></mat-datepicker>
                                        <mat-error *ngIf="detailsFormGroup.controls['startDate'].invalid">Please enter valid start date.</mat-error>
                                    </mat-form-field>
                                </td>
                            </tr>
                            <tr>
                                <td><span class="label-text">End</span></td>
                                <td>
                                    <mat-form-field>
                                        <input matInput [matDatepicker]="endPicker" formControlName="endDate" [min]="minEndDate"
                                            (dateChange)="calculateContractDates('endDateChanged')" data-qa-id="EndDateInput">
                                        <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
                                        <mat-datepicker #endPicker></mat-datepicker>
                                        <mat-error *ngIf="detailsFormGroup.controls['endDate'].invalid">Please enter valid end date.</mat-error>
                                    </mat-form-field>
                                </td>
                            </tr>
                        </ng-container>

                        <ng-container>
                            <tr>
                                <td>
                                    <span class="label-text">Shift Type <span>*</span></span>
                                </td>

                                <td>
                                    <mat-form-field class="mc-form-field mc-form-field__shift-type--width">
                                        <mat-select formControlName="shiftTypeId">
                                            <mat-option *ngFor="let option of lookups?.shiftTypes" [value]="option.key">{{ option.value }}</mat-option>
                                        </mat-select>
                                        <mat-error *ngIf="hasError('shiftTypeId', 'required')">Shift Type is required</mat-error>
                                    </mat-form-field>
                                </td>
                            </tr>

                            <tr>
                                <td>
                                    <span class="label-text"># of Shifts <span>*</span></span>
                                </td>
                                <td [ngClass]="{'twoColTd' : viewAltShift}">
                                    <mat-form-field class="mc-form-field mc-form-field__shift-type--width tdSplit">
                                        <mat-select formControlName="shifts" (selectionChange)="calculateContractDates('numOfShiftsChanged')">
                                            <mat-option *ngFor="let num of shiftValues" [value]="num">{{ num }}</mat-option>
                                        </mat-select>
                                        <mat-error *ngIf="hasError('shifts', 'required')"># of Shifts is required</mat-error>
                                    </mat-form-field>

                                    <mat-form-field *ngIf="viewAltShift" class="mc-form-field mc-form-field__shift-type--width tdSplit">
                                        <mat-select formControlName="shiftsAlt">
                                            <mat-option *ngFor="let num of shiftValues" [value]="num">{{ num }}</mat-option>
                                        </mat-select>
                                        <mat-error *ngIf="hasError('shiftsAlt', 'required')"># of Alt Shifts is required</mat-error>
                                    </mat-form-field>
                                </td>
                            </tr>

                            <tr>
                                <td>
                                    <span class="label-text" >Shift Length <span>*</span></span>
                                </td>
                                <td [ngClass]="{'twoColTd' : viewAltShift}">
                                    <div class="tdSplit">
                                        <mat-form-field class="mc-form-field mc-form-field__shift-type--width">
                                            <mat-select formControlName="hours" (selectionChange)="checkRateUpdateFields('Shift Length')">
                                                <mat-option *ngFor="let length of hoursValue" [value]="length">{{ length }}</mat-option>
                                            </mat-select>
                                            <mat-error *ngIf="hasError('hours', 'required')">Shift Length is required</mat-error>
                                        </mat-form-field>
                                        <span class="label-text ml">Hours</span>
                                    </div>
                                    <div class="tdSplit" *ngIf="viewAltShift">
                                        <mat-form-field class="mc-form-field mc-form-field__shift-type--width">
                                            <mat-select formControlName="hoursAlt" (selectionChange)="onShiftLengthAltChanged()">
                                                <mat-option *ngFor="let length of hoursValue" [value]="length">{{ length }}</mat-option>
                                            </mat-select>
                                            <mat-error *ngIf="hasError('hoursAlt', 'required')">Alt Shift Length is required</mat-error>
                                        </mat-form-field>
                                        <span class="label-text ml">Hours</span>
                                    </div>
                                </td>
                            </tr>

                            <tr>
                                <td>
                                    <span class="label-text">Shift Time of Day <span>*</span></span>
                                </td>
                                <td [ngClass]="{'twoColTd' : viewAltShift || isRotatingShift}">
                                    <mat-form-field class="mc-form-field mc-form-field__shift-type--width tdSplit">
                                        <mat-select formControlName="shiftTimeOfDayId" (selectionChange)="checkRateUpdateFields('Shift Time of Day')" >
                                            <mat-option *ngFor="let option of lookups?.shiftTimes" [value]="option.key">{{ option.value }}</mat-option>
                                        </mat-select>
                                        <mat-error *ngIf="hasError('shiftTimeOfDayId', 'required')">Shift Time of Day is required</mat-error>
                                    </mat-form-field>

                                    <mat-form-field *ngIf="viewAltShift || isRotatingShift" class="mc-form-field mc-form-field__shift-type--width tdSplit">
                                        <mat-select formControlName="shiftAltTimeOfDayId">
                                            <mat-option *ngFor="let option of lookups?.shiftTimes" [value]="option.key">{{ option.value }}</mat-option>
                                        </mat-select>
                                        <mat-error *ngIf="hasError('shiftAltTimeOfDayId', 'required')">Alt Shift Time of Day is required</mat-error>
                                    </mat-form-field>
                                </td>
                            </tr>

                            <tr>
                                <td>
                                    <span class="label-text">Shift Time</span>
                                    <span class="under-label">Optional</span>
                                </td>
                                <td [ngClass]="{'twoColTd' : viewAltShift || isRotatingShift}">
                                    <div class="tdSplit">
                                        <table class="inner-table" aria-label="shift times">
                                            <tr class="hidden">
                                                <th scope="col"></th>
                                                <th scope="col"></th>
                                                <th scope="col"></th>
                                            </tr>
                                            <tr>
                                                <td><span class="label-text">Start</span></td>
                                                <td>
                                                    <kendo-timepicker class="kendo-input-field"
                                                        formControlName="shiftTimeStart"
                                                        (valueChange)="onTimeStartChanged($event)" format="HH:mm">
                                                    </kendo-timepicker>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td><span class="label-text">End</span></td>
                                                <td>
                                                    <kendo-timepicker class="kendo-input-field"
                                                        formControlName="shiftTimeEnd"
                                                        (valueChange)="onTimeEndChanged($event)" format="HH:mm">
                                                    </kendo-timepicker>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                    <div class="tdSplit" *ngIf="viewAltShift || isRotatingShift">
                                        <table class="inner-table" aria-label="alt shift times">
                                            <tr class="hidden">
                                                <th scope="col"></th>
                                                <th scope="col"></th>
                                                <th scope="col"></th>
                                            </tr>
                                            <tr>
                                                <td><span class="label-text">Start</span></td>
                                                <td>
                                                    <kendo-timepicker class="kendo-input-field"
                                                        formControlName="shiftAltTimeStart"
                                                        (valueChange)="onAltTimeStartChanged($event)" format="HH:mm">
                                                    </kendo-timepicker>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td><span class="label-text">End</span></td>
                                                <td>
                                                    <kendo-timepicker class="kendo-input-field"
                                                        formControlName="shiftAltTimeEnd"
                                                        (valueChange)="onAltTimeEndChanged($event)" format="HH:mm">
                                                    </kendo-timepicker>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td><span class="label-text">Shift Details</span></td>
                                <td>
                                    <textarea formControlName="shiftDetails" class="other-notes-textarea"></textarea>
                                </td>
                            </tr>

                        </ng-container>

                        <tr><td colspan="2"></td></tr>
                        <tr>
                            <td><span class="label-text">RTO</span></td>
                            <td>
                                <mat-checkbox formControlName="hasRequestedTimeOff"></mat-checkbox>
                            </td>
                        </tr>

                        <ng-container *ngIf="detailsFormGroup.controls.hasRequestedTimeOff.value">
                            <tr>
                                <td><span class="label-text">RTO Dates</span></td>
                                <td>
                                    <div class="rto-container">
                                        <div class="date-input-container">
                                            <div class="days">
                                                <span>{{ daysRequested }}</span>
                                            </div>
                                            <button class="rto-btn" mat-icon-button [matMenuTriggerFor]="appMenu">
                                                <mat-icon>event</mat-icon>
                                            </button>
                                        </div>

                                        <mat-menu #appMenu="matMenu" class="drop-calendar" >
                                            <div (click)="$event.stopPropagation()">
                                                <mat-calendar #calendar class="mat-calendar" [dateClass]="dateClass()" [maxDate]="maxDate" [minDate]="minDate" (selectedChange)="dateChanged($event)"></mat-calendar>
                                            </div>
                                        </mat-menu>

                                        <a class="nova-link rto-clear__btn" [class.disabled]="daysSelected.length ?  false : true" (click)="clearDates()" #clearCalendarTrigger="matMenuTrigger" [matMenuTriggerFor]="appMenu">Clear</a>
                                    </div>
                                    <div class="offer-rto-warning">
                                        <nova-rto-warning-message [enabled]="enableRtoAlertMessageforApnOfferFlag() && showRTOAlertOnStartEndDatesForApnOffer">                                      
                                        </nova-rto-warning-message> 
                                    </div>   
                                </td>
                            </tr>
                            <tr>
                                <td><span class="label-text">RTO Approval</span></td>
                                <ng-container>
                                    <td>
                                        <mat-form-field class="mc-form-field mc-form-field__shift-type--width">
                                            <mat-select formControlName="rtoApprovalStatus">
                                                <mat-option [value]="1">Approved</mat-option>
                                                <mat-option [value]="2">Pending Approval</mat-option>
                                                <mat-option [value]="3">Not Approved</mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </td>
                                </ng-container>
                            </tr>
                        </ng-container>
                        <tr><td colspan="2"></td></tr>
                        <tr>
                            <td><span class="label-text">Facility Rate</span></td>
                            <td>
                                <span class="label-text mr">$</span>
                                <mat-form-field>
                                    <input type="number" matInput formControlName="facilityRate"
                                        (keyup)="updateVendorRate()"
                                        (change)="calculateContractDates('facilityRateChanged')">
                                </mat-form-field>

                            </td>
                        </tr>
                        <tr>
                            <td><span class="label-text">Vendor Rate</span></td>
                            <td>
                                <span class="label-text mr">$</span>
                                <mat-form-field>
                                    <input type="number" matInput formControlName="vendorRate">
                                </mat-form-field>
                            </td>
                        </tr>
                        <tr><td colspan="2"></td></tr>
                        <tr>
                            <td><span class="label-text">Other Details</span></td>
                            <td>
                                <textarea formControlName="otherDetails" class="other-notes-textarea"></textarea>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </form>
        </mat-card>
        <mat-card class="notes">
        </mat-card>
    </div>
</div>
